<div class="grid-container padding-y-4">
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--large">{{title}}</legend>
        </div>
    </div>
    <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            For Domestic and International Shipments
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            Relocation Services Companies(RSC) and Transportation Service Provider (TSP), please click the "Initiate" button to initiate the Survey
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            <button type="button" class="usa-button" (click)="initiateSurvey()">Initiate</button>
        </div>
    </div>
    <div class="grid-row grid-gap-1 padding-top-205">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
            Please enter your Survey Number and select “Continue”
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <input class="usa-input maxw-full" type="text" [(ngModel)]="surveyNo">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <button type="button" class="usa-button margin-left-2 pin-bottom" (click)="continueSurvey()" [disabled]="surveyNo === null || surveyNo === '' || surveyNo === undefined ">Continue</button>
        </div>
    </div>
</div>